import React, {Component} from 'react';
import './Headline.css';

class Headline extends Component {
    render(){
        let theme;
        if(this.props.span) {
            theme = this.props.tag + ' ';
        }else{
            theme = '';
        }


        if(this.props.brand) {
            theme += "brand-" + this.props.brand;
        }else{
            theme += "brand-default"
        }
        if(this.props.additionalClassname) {
            theme += " " + this.props.additionalClassname;
        }
        if(this.props.span) {
         return <span className={theme}>{this.props.label}</span>
        }else{
            if(this.props.tag === 'h1') {
                return <h1 className={theme}>{this.props.label}</h1>
            }else if(this.props.tag === 'h2') {
                return <h2 className={theme}>{this.props.label}</h2>
            }else if(this.props.tag === 'h3') {
                return <h3 className={theme}>{this.props.label}</h3>
            }else if(this.props.tag === 'h4') {
                return <h4 className={theme}>{this.props.label}</h4>
            }else {
                return <h5 className={theme}>{this.props.label}</h5>
            }
        }
    }
}

export default Headline;


// WEBPACK FOOTER //
// ./src/Components/Elements/Headline/Headline.js